'use client';
import{useEnvHooks as e}from"./evnHooks.mjs";import{jsx as r,Fragment as o}from"react/jsx-runtime";function t(t){let{memberInfo:n,appInfo:i,isAutoNaverCertDisabled:m,children:a}=t;return e({memberInfo:n,appInfo:i,isAutoNaverCertDisabled:m}),r(o,{children:a})}export{t as SimplepayLayerProvider};
